import { render, staticRenderFns } from "./EnableFormSwitch.vue?vue&type=template&id=7ff87934&scoped=true"
import script from "./EnableFormSwitch.vue?vue&type=script&lang=ts"
export * from "./EnableFormSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff87934",
  null
  
)

export default component.exports